import React, { Suspense } from 'react';
import type { ViewSwitcherPopoverScreenProps } from './ArrangeViewButtonsPopoverScreen';
import type { FunctionComponent } from 'react';

import { useLazyComponent } from '@trello/use-lazy-component';
import { Spinner } from '@trello/nachos/spinner';
import { ChunkLoadErrorBoundary } from '@trello/error-reporting';

export const LazyArrangeViewButtonsPopoverScreen: FunctionComponent<ViewSwitcherPopoverScreenProps> = (
  props,
) => {
  const ArrangeViewButtonsPopoverScreen = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "arrange-view-buttons-popover-screen" */ './ArrangeViewButtonsPopoverScreen'
      ),
    { preload: false, namedImport: 'ArrangeViewButtonsPopoverScreen' },
  );

  return (
    <ChunkLoadErrorBoundary fallback={null}>
      <Suspense fallback={<Spinner />}>
        <ArrangeViewButtonsPopoverScreen {...props} />
      </Suspense>
    </ChunkLoadErrorBoundary>
  );
};
